import React from "react";
import { useRouteMatch } from "react-router-dom";

import styled from "styled-components/macro";

import {
  animate,
  initial,
} from "Signups/SignupsPublicPage/SignupHeader/animation.js";
import { AnimatePresence, motion } from "framer-motion";

import FnrButton from "UI/FnrButton3";

import { useIsSignupClosed } from "./useIsSignupClosed";

export default function SignupClosed() {
  const { isClosed } = useIsSignupClosed();

  const singlePageApp = Boolean(useRouteMatch("/signup/:signupID"));

  if (isClosed) {
    return (
      <AnimatePresence>
        <Wrapper
          singlePageApp={singlePageApp}
          initial={initial}
          animate={animate}
        >
          This signup has closed.
          {singlePageApp && (
            <ButtonWrapper>
              <FnrButton
                style={{ marginTop: 6 }}
                size="small"
                onClick={() => (window.location = "/")}
              >
                Connect with us on Flocknote
              </FnrButton>
            </ButtonWrapper>
          )}
        </Wrapper>
      </AnimatePresence>
    );
  }

  return null;
}

const Wrapper = styled(motion.div)`
  background-image: linear-gradient(
    to right bottom,
    #fad755,
    #f6c23f,
    #f2ac2b,
    #ed9517,
    #e87e04
  );
  text-align: center;
  position: relative;
  padding: 20px;
  font-size: 24px;
  font-weight: 400;
  border-radius: 8px;
  margin-top: ${({ singlePageApp }) => (singlePageApp ? "30px" : "11px")};
  margin-bottom: 20px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;
